<template>
    <div >
        <div class="version">v{{version}}</div>
        <div class="desc" >
           {{desc}}
        </div>
    </div>
</template>

<script>
    import { Field} from 'vant';
    export default {
        name: "info",
        components:{
            [Field.name]:Field,
        },
        data(){
            return {
                version: '',
                desc: '',
            }
        },
        mounted() {
            
            this.util.hideOptionMenu();
            this.version = process.env.VUE_APP_VERSION
            this.desc = process.env.VUE_APP_VERSION_DESC
        },
        methods:{
            
        }
    }
</script>

<style scoped>
    .version {
        font-size: 15px;
        font-weight: 600;
        text-align: center;
        margin-top: 50px;
    }
    .desc{
        padding: 20px;
    }

</style>
